import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useNavigate, useLocation } from "react-router-dom";
import { useSignup } from "../context/signUpContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const SignupPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { selectedPlan } = location.state || {};
  const { setCompletedSteps } = useSignup();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [image, setImage] = useState(null);
  const [error, setError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  console.log("plani i selektum",selectedPlan);
  const handleFileChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleNext = async (e) => {
    e.preventDefault();

    if (!name || !email || !password || !confirmPassword || !phoneNumber) {
      toast.error("Please fill in all required fields.");
      return;
    }

    const emailRegex = /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/;
    const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address.");
      return;
    }
    
    if (!passwordRegex.test(password)) {
      toast.error(
        "Password must be at least 8 characters, include one uppercase letter, one lowercase letter, one number, and one special character."
      );
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }

    const formData = new FormData();
    formData.append("password", password);
    formData.append("email", email);
    formData.append("name", name);
    formData.append("phone_number", phoneNumber);
    formData.append("account_status", "active");
    formData.append("role", selectedPlan?.role);

    if (image) formData.append("image", image);

    try {
      const response = await fetch("https://api.theonlysale.com/api/user/post", {
        method: "POST",
        body: formData,
      });
      const responseData = await response.json();

      if (!response.ok) throw new Error(responseData.message || "Failed to sign up");

      setCompletedSteps((prev) => ({ ...prev, signUp: true }));
      navigate("/subscribtion", { state: { selectedPlan, email } });
    } catch (error) {
      console.error("Error:", error);
      toast.error(error.message);
    }
  };

  const handlePrev = () => {
    navigate("/personal-info", { state: { selectedPlan } });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };
  return (
    <>
          <ToastContainer />

      <Header />
      <div className="min-h-screen p-5 flex items-center justify-center bg-white dark:bg-gray-900">
        <div className="flex flex-col md:flex-row bg-white rounded-lg shadow-lg overflow-hidden w-full md:max-w-4xl">
          <div className="bg-blue-600 p-8 flex flex-col justify-between text-white w-full md:w-1/3 dark:bg-blue-800">
            <div>
              <h2 className="text-2xl md:text-3xl font-semibold mb-6">
                Your selected plan
              </h2>
              {selectedPlan ? (
                <>
                  <h3 className="text-xl md:text-2xl font-bold">{selectedPlan.title}</h3>
                  <p className="text-lg">{selectedPlan.price}/month</p>
                  <ul className="mt-4 space-y-2">
                    {selectedPlan.features.map((feature, index) => (
                      <li key={index} className="flex items-center">
                        <FontAwesomeIcon icon={faCheck} className="w-6 h-6 mr-2" />
                        {feature}
                      </li>
                    ))}
                  </ul>
                </>
              ) : (
                <p>No plan selected.</p>
              )}
            </div>
            <div className="mt-4">
              <a href="#" className="text-white text-sm underline">
                Go back
              </a>
            </div>
          </div>
  
          <div className="bg-white w-full md:w-2/3 p-6 md:p-12 flex flex-col justify-between dark:bg-gray-800">
  <div className="space-y-6">
    <div className="flex flex-wrap items-center justify-between">
      {/* Step 1 - Active */}
      <div className="flex items-center text-sm md:text-lg font-semibold text-blue-600 dark:text-blue-400">
        <FontAwesomeIcon
          icon={faCheck}
          className="mr-2"
          style={{ color: "#4964ED", width: "20px", height: "20px" }}
        />
        Personal Info
      </div>

      {/* Step 2 */}
      <div className="flex items-center text-sm md:text-lg font-semibold text-gray-300 dark:text-gray-600">
        2 Account Info
      </div>

      {/* Step 3 */}
      <div className="flex items-center text-sm md:text-lg font-semibold text-gray-300 dark:text-gray-600">
        3 Payment
      </div>

      {/* Step 4 */}
      <div className=" flex items-center text-sm md:text-lg font-semibold text-gray-300 dark:text-gray-600">
        4 Confirmation
      </div>
    </div>


  
              <h3 className="text-2xl font-semibold mb-4 text-black dark:text-white">
                Account details
              </h3>
  
              <form onSubmit={handleNext}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" htmlFor="name">
                      Full Name
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      placeholder="Bonnie"
                      className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-300"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" htmlFor="email">
                      Your email
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="name@company.com"
                      className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-300"
                    />
                  </div>
                </div>
  
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" htmlFor="password">
                      Password
                    </label>
                    <div className="relative">
                      <input
                        type={showPassword ? "text" : "password"}
                        id="password"
                        name="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-300"
                      />
                      <button
                        type="button"
                        onClick={togglePasswordVisibility}
                        className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5"
                        aria-label="Toggle password visibility"
                      >
                        <FontAwesomeIcon
                          icon={showPassword ? faEyeSlash : faEye}
                          className="text-gray-500 dark:text-white"
                        />
                      </button>
                    </div>
                  </div>
  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" htmlFor="confirmPassword">
                      Confirm Password
                    </label>
                    <div className="relative">
                      <input
                        type={showConfirmPassword ? "text" : "password"}
                        id="confirmPassword"
                        name="confirmPassword"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-300"
                      />
                      <button
                        type="button"
                        onClick={toggleConfirmPasswordVisibility}
                        className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5"
                        aria-label="Toggle confirm password visibility"
                      >
                        <FontAwesomeIcon
                          icon={showConfirmPassword ? faEyeSlash : faEye}
                          className="text-gray-500 dark:text-white"
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      Phone
                    </label>
                    <input
                      type="text"
                      name="phone_number"
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      placeholder="+123 567 890"
                      className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-300"
                    />
                  </div>
                </div>

                <div className="mb-6">
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Profile Picture
                  </label>
                  <div className="flex items-center space-x-4">
                    {image && (
                      <div className="relative group">
                        <img
                          src={URL.createObjectURL(image)}
                          alt="Profile Preview"
                          className="w-28 h-28 object-cover rounded-full border-4 border-blue-500 dark:border-gray-500 transition-transform duration-300 ease-in-out group-hover:scale-105"
                        />
                        <div className="absolute inset-0 bg-black bg-opacity-50 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200 cursor-pointer">
                          <span className="text-white text-sm font-semibold">
                            Change
                          </span>
                        </div>
                      </div>
                    )}
                    <label className="cursor-pointer inline-block">
                      <input
                        type="file"
                        name="image"
                        accept="image/*"
                        onChange={handleFileChange}
                        className="hidden"
                      />
                      <div className="flex items-center justify-center w-48 px-4 py-2 bg-blue-600 dark:bg-blue-500 text-white text-sm font-medium rounded-lg shadow-lg hover:bg-blue-700 dark:hover:bg-blue-600 transition-colors duration-200">
                        Upload New Photo
                      </div>
                    </label>
                  </div>
                </div>
  
                <div className="mb-6">
                  <label className="flex items-center text-sm text-gray-700 dark:text-gray-300">
                    <input
                      type="checkbox"
                      className="mr-2 rounded border-gray-300 dark:border-gray-600 focus:ring-blue-600"
                    />
                    By signing up, you agree to the Terms of Use and Privacy Policy.
                  </label>
                </div>
  
                {error && (
                  <div className="text-red-600 dark:text-red-400 mb-4">{error}</div>
                )}
  
                <div className="flex justify-between">
                  <button
                    type="button"
                    className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-200 dark:bg-gray-700 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600"
                    onClick={handlePrev}
                  >
                    Prev: Personal Info
                  </button>
                  <button
                    type="submit"
                    className="px-6 py-2 text-sm font-medium text-white bg-blue-600 dark:bg-blue-500 rounded-lg hover:bg-blue-700 dark:hover:bg-blue-600"
                  >
                    Next: Account Info
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
  
};

export default SignupPage;
